import {enableProdMode, LOCALE_ID, TRANSLATIONS, TRANSLATIONS_FORMAT} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';

import { environment } from './environments/environment';

import 'hammerjs';
import {MatPaginatorIntl} from '@angular/material';
import {PaginatorIntl} from './app/core/utils/paginator-intl';
import {I18n} from '@ngx-translate/i18n-polyfill';


if (environment.production) {
  enableProdMode();
}

// platformBrowserDynamic().bootstrapModule(AppModule);

declare const require;
const locale = document['locale'] as string;

// try {
// const translations = require(`raw-loader!./locale/messages.${locale}.xlf`);
const translations = require(`raw-loader!./locale/messages.fr.xlf`);
platformBrowserDynamic().bootstrapModule(AppModule, {
  providers: [
    { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
    { provide: TRANSLATIONS, useValue: require('raw-loader!./locale/messages.fr.xlf') },
    { provide: LOCALE_ID, useValue: 'fr' },
    // { provide: MatPaginatorIntl, useClass: PaginatorIntl },
    // { provide: TRANSLATIONS, useValue: translations },
    // { provide: TRANSLATIONS_FORMAT, useValue: 'xlf' },
  ]
});
// } catch (e) {
//   platformBrowserDynamic().bootstrapModule(AppModule);
// }
// import { getTranslationProviders } from './app/i18n-providers';



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/main.ts